module.exports = __webpack_public_path__ + "img/b2b.7d7a9b17.png";